import React from 'react';
import { connect, Provider } from "react-redux";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import { getSupportBrands, getGroupsLookup, getSupportForms, getTicketFields, getTicketCreationFields, getTicketLoading, getTicketDrawerApiStatus, makeUserDetails } from "../Header/Header.selector";
import { store } from '../Header';
import CreateTicket from './CreateTicket';
import { fetchSupportBrands, setSupportForm, createNewTicket, fetchTicketFields, fetchTicketCreationFields } from './CreateTicket.action';
const mapStateToProps = createStructuredSelector({
  supportBrands: getSupportBrands(),
  supportForms: getSupportForms(),
  groupsLookup: getGroupsLookup(),
  ticketFields: getTicketFields(),
  ticketLoading: getTicketLoading(),
  ticketDrawerApiStatus: getTicketDrawerApiStatus(),
  ticketCreationFields: getTicketCreationFields(),
  userDetails: makeUserDetails()
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchSupportBrands,
    setSupportForm,
    createNewTicket,
    fetchTicketFields,
    fetchTicketCreationFields
  }, dispatch)
});
const CreateTicketContainer = connect(mapStateToProps, mapDispatchToProps)(CreateTicket);
export default (props => /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(CreateTicketContainer, props)));